export default __webpack_public_path__ + "static/media/sALPACA.95204ff2.svg";